import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route } from '@angular/router';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {

  constructor(public route: ActivatedRoute) { }
  code = ""
  ngOnInit(): void {
    this.route.queryParamMap.pipe(take(1)).subscribe((params) => {
      this.code = params.get('code') ?? '';

      /* dá 300 ms para o modal aparecer antes de sair;
         ajuste ou remova o setTimeout se não quiser delay */
      setTimeout(() => {
        window.location.replace(
          `https://seu.palpit.in/?cupom=${encodeURIComponent(this.code)}`
        );
      }, 50);
    });
  }

}
